import { render, staticRenderFns } from "./SubcardContainer.vue?vue&type=template&id=cb1a242c&"
import script from "./SubcardContainer.vue?vue&type=script&lang=js&"
export * from "./SubcardContainer.vue?vue&type=script&lang=js&"
import style0 from "./SubcardContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports